const { plan } = require('../tool/plan.js');
const { cpps } = require('../tool/cppid.js');

let RE = {
    game:'dicero',  //游戏名称

    isShowModal: true,  //是否显示弹窗
    isPost: false,  //弹窗是否后置
    modalType: 1,   //弹窗类型          7种
    modalBtnType: 1,  //弹窗按钮类型     5种    英文没有1 3
    bannerType: 1,  //banner类型        3种
    bannerBtnType: 1,   //banner按钮      5种   英文没有1 3
    tabType: false,     // 头图导图是否特殊处理
    detailType: 1,  //详情页类型      1种
    language: 'TW',    //语言

    os: null,       //操作系统

    appType: '',       //app类型
    planid: '',  //版本号  根据版本号会获取上述配置

    cppid: null,  //识别cppid 跳转不同连接  -- iOS默认是从1到99，and是100及以上
    url: '',  //跳转地址
    iosUrl: 'https://apps.apple.com/th/app/heround/id6740966864',  //默认地址
    AndUrl: 'https://apps.apple.com/th/app/heround/id6740966864',  //默认地址

    FB: 'https://www.facebook.com/Dicero.HMT/posts/pfbid02fb1QFubL2VDtA7H27trLZvq3o2BvQqbU46WyjdZrh42B7YMvB1wVyFaSKpS21hLzl?rdid=Ohirm5ORO2aq4GTu#',
    X: 'https://x.com/Dicero_JP/status/2030950179076284804',
    naver: 'https://game.naver.com/lounge/dicerco/board/detail/7403026',

    pid: null,  //渠道  fb/gg/tt/x
    imgsUrl: 'https://dicero.habby.com',    //图片地址

    track: 'dicero',       //打点名称
    sandbox: null,  //是否是沙盒环境

    c: '',
    adset: '',
    ad: '',
}
// 弹窗
let modalObj = {
    'a' : 1,
    'b' : 2,
    'c' : 3,
    'd' : 4,
    'e' : 5,
    'f' : 6,
    'g' : 7,
}
// 按钮
let btnObj = {
    'Y1' : 1,
    'Y2' : 2,
    'B1' : 3,
    'B2' : 4,
    'C' : 5,
}
// 详情页
let detailObj = {
    '11' : 1,
}

if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(new URL(window.location.href).search);

    const ipPattern = /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
    RE.sandbox = (window.location.hostname.includes('test-') || window.location.hostname == 'localhost' || ipPattern.test(window.location.hostname)) ? true : false;  //是否是沙盒环境
    RE.imgsUrl = (window.location.hostname == 'localhost' || ipPattern.test(window.location.hostname)) ? '' : (window.location.hostname.includes('test-') ? 'https://test-dicero.habby.com' : 'https://dicero.habby.com');  //是否是沙盒环境

    const paramsObject = {};
    urlParams.forEach((value, key) => {
        paramsObject[key] = value;
    });

    if(paramsObject.pid){
        RE.pid = paramsObject.pid || null;
    }

    RE.c = paramsObject.c || '';
    RE.adset = paramsObject.adset || '';
    RE.ad = paramsObject.ad || '';

    let array = plan.filter(item => item.planid == paramsObject.plan);

    if(array.length > 0){

        RE.isPost = array[0].isPost == '是' ? true : false;

        if (RE.isPost) {
            RE.isShowModal = false;
        } else {
            RE.isShowModal = array[0].isShowModal == '有' ? true : false;
        }

        RE.modalType = modalObj[array[0].modalType] || 1;
        
        if (array[0].modalBtnType) {
            RE.modalBtnType = btnObj[array[0].modalBtnType] || 1;
        }

        RE.bannerType = array[0].bannerType <= 3 ?  array[0].bannerType : 1;

        if (array[0].bannerBtnType) {
            RE.bannerBtnType = btnObj[array[0].bannerBtnType] <= 7 ? btnObj[array[0].bannerBtnType] : 1;
        } else {
            RE.bannerBtnType = RE.bannerType;
        }

        RE.tabType = array[0].tabType && array[0].tabType == 'T1' ? true : false;
        RE.detailType = detailObj[array[0].detailType] <= 2 ? detailObj[array[0].detailType] : 1;
        RE.language = array[0].language || 'TW';
        RE.planid = array[0].planid;
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 检查是否是 Android 设备
    if (/android/i.test(userAgent) || /Win32|Win64|Windows|WinCE/.test(userAgent)) {
        RE.os = 0;
    }

    // 检查是否是 iOS 设备
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream || /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
        RE.os = 1;
    }

    let cppObj = cpps.filter(item => item.cppid == paramsObject.cppid);
    if(cppObj.length > 0){
        RE.cppid = cppObj[0].cppid || 100;         //-- iOS默认是从1到99，and是100及以上
        let sys = cppObj[0].system;
        if (sys == 'iOS'){
            RE.url = RE.os == 1 ? cppObj[0].url : RE.iosUrl;
        }
        if (sys == 'AND'){
            RE.url = RE.os == 0 ? cppObj[0].url : RE.AndUrl;
        }
    }

    if(!RE.url){
        RE.url = RE.os == 1 ? RE.iosUrl : RE.AndUrl;
    }
}
// console.log(RE, 'RE');

module.exports = RE;
